module.exports = __webpack_public_path__ + "img/qd1@2x.bf5df074.png";